<template>
  <div>
    <a-form id="formLogin"
              class="user-layout-login"
              ref="formLogin"
              :form="form">
        <!--大框  -->
            <!-- 手机号 -->
          <a-form-item style="margin-bottom: 20px;">
            <a-input size="default"
                     type="text"
                     placeholder="请输入手机号"
                     v-decorator="['mobile', {rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请输入手机号' }], validateTrigger: 'change'}]">
              <a-icon slot="prefix"
                      type="mobile"
                      :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

            <a-row :gutter="15">
            <a-col class="gutter-row"
                   :span="15">
              <!-- 验证码 -->
              <a-form-item>
                <a-input size="default"
                         type="text"
                         placeholder="验证码"
                         v-decorator="['captcha', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                  <a-icon slot="prefix"
                          type="mail"
                          :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-item>
            </a-col>
            <!-- 获取验证码 -->
            <a-col class="gutter-row"
                   :span="9">
              <a-button class="getCaptcha"
                        tabindex="-1"
                        :disabled="state.smsSendBtn"
                        @click.stop.prevent="getCaptcha"
                        >{{ !state.smsSendBtn && '获取验证码' || (state.time+' s') }}</a-button>
            </a-col>
          </a-row>

        <!-- 自动登录、忘记密码 -->
        <!-- 忘记密码无页面!!! -->
        <!-- <a-form-item>
          <a-checkbox v-decorator="['rememberMe', { valuePropName: 'checked' }]">{{ $t('user.login.remember-me') }}</a-checkbox>
          <router-link :to="{ name: 'recover', params: { user: 'aaa'} }"
                       class="forge-password"
                       style="float: right;">{{ $t('user.login.forgot-password') }}</router-link>
        </a-form-item> -->
  
        <!--  登录按钮  -->
        <a-form-item>
          <a-button 
          style="width: 100%;margin-top: 2px;"
          size="large"
                    type="primary"
                    htmlType="submit"
                    class="login-button"
                    :loading="state.loginBtn"
                    :disabled="state.loginBtn">下一步</a-button>
      
          
        </a-form-item>
      </a-form>
  </div>
</template>

<script>
export default {
    data() {
      return {
        form: this.$form.createForm(this),
        customActiveKey: 'account',
        state: {
          time: 60,
          loginBtn: false,
          // login type: 0 email, 1 username, 2 telephone
          loginType: 0,
          smsSendBtn: false
        }
      }
    },
}
</script>

<style>
  .getCaptcha {
      display: block;
      width: 100%;
      height: 50px;
    }
    .steps {
    max-width: 550px;
    margin: 16px auto;
  }
</style>